export const normalizeOgrnDigits = (value: string): string => value.replace(/\D/g, '')

export const OGRN_LEGAL_ENTITY_LENGTH = 13
export const OGRN_SOLE_TRADER_LENGTH = 15

/** ОГРНИП длиннее ОГРН на две цифры — по длине и различаем предпринимателя от юрлица. */
export const isSoleTraderOgrn = (value: string): boolean =>
  normalizeOgrnDigits(value).length === OGRN_SOLE_TRADER_LENGTH

/**
 * Контрольная цифра. Правило разное для двух форм: у ОГРН остаток от деления первых 12 цифр на 11,
 * у ОГРНИП — первых 14 на 13; сравнивается последняя цифра остатка.
 *
 * Проверять её стоит на клиенте, хотя бэкенд делает то же самое: опечатка в номере ловится сразу,
 * а не после отправки формы. Число до 14 цифр в double не помещается точно, поэтому считаем
 * остаток посимвольно.
 */
export const isValidOgrn = (value: string): boolean => {
  const digits = normalizeOgrnDigits(value)
  const divisor =
    digits.length === OGRN_LEGAL_ENTITY_LENGTH
      ? 11
      : digits.length === OGRN_SOLE_TRADER_LENGTH
        ? 13
        : null
  if (divisor == null) {
    return false
  }
  let remainder = 0
  for (const char of digits.slice(0, -1)) {
    remainder = (remainder * 10 + Number(char)) % divisor
  }
  return remainder % 10 === Number(digits[digits.length - 1])
}

/** Сообщение для формы: объясняет, что не так, а не просто «неверный формат». */
export const ogrnValidationMessage = (value: string, required = true): string | null => {
  const trimmed = value.trim()
  if (!trimmed) {
    return required ? 'Укажите ОГРН или ОГРНИП.' : null
  }
  const digits = normalizeOgrnDigits(trimmed)
  if (digits.length !== OGRN_LEGAL_ENTITY_LENGTH && digits.length !== OGRN_SOLE_TRADER_LENGTH) {
    return `ОГРН состоит из 13 цифр, ОГРНИП — из 15. Сейчас цифр: ${digits.length}.`
  }
  if (!isValidOgrn(digits)) {
    return 'Контрольная цифра номера не сходится — проверьте, нет ли опечатки.'
  }
  return null
}

/** Подпись реквизита в интерфейсе и документах. */
export const ogrnLabel = (value: string): string => (isSoleTraderOgrn(value) ? 'ОГРНИП' : 'ОГРН')
